import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mail, Lock, User, ArrowRight } from 'lucide-react';

export default function AuthPage() {
  const [mode, setMode] = useState('login');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') {
        await login(email, password);
      } else {
        await register(name, email, password);
      }
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al procesar tu solicitud');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[var(--cream)] flex items-center justify-center px-4 py-12" data-testid="auth-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/">
            <img src="https://customer-assets.emergentagent.com/job_aura-k-beauty/artifacts/5z4fhs5o_1.png" alt="Aura K Beauty" className="h-14 mx-auto mb-6 rounded" />
          </Link>
          <h1 className="text-2xl font-bold text-[var(--dark)]">
            {mode === 'login' ? 'Bienvenida de vuelta' : 'Crea tu cuenta'}
          </h1>
          <p className="text-sm text-[var(--dark)]/50 mt-2">
            {mode === 'login' ? 'Ingresa para continuar tu experiencia K-Beauty' : 'Unete a la comunidad Aura K Beauty'}
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 shadow-sm border border-[var(--sage)]/20">
          <form onSubmit={handleSubmit} className="space-y-5">
            {mode === 'register' && (
              <div className="space-y-2">
                <Label className="text-sm text-[var(--dark)]/70">Nombre</Label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--dark)]/30" />
                  <Input value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" className="pl-10 rounded-xl border-[var(--sage)] h-11" required data-testid="register-name-input" />
                </div>
              </div>
            )}
            <div className="space-y-2">
              <Label className="text-sm text-[var(--dark)]/70">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--dark)]/30" />
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" className="pl-10 rounded-xl border-[var(--sage)] h-11" required data-testid="email-input" />
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-sm text-[var(--dark)]/70">Contrasena</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--dark)]/30" />
                <Input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Tu contrasena" className="pl-10 rounded-xl border-[var(--sage)] h-11" required data-testid="password-input" />
              </div>
            </div>

            {error && <p className="text-sm text-red-500 text-center" data-testid="auth-error">{error}</p>}

            <Button type="submit" disabled={loading} className="w-full h-12 bg-[var(--violet)] hover:bg-[var(--violet-dark)] text-white rounded-xl text-base font-semibold btn-shimmer" data-testid="auth-submit-btn">
              {loading ? 'Procesando...' : mode === 'login' ? 'Ingresar' : 'Crear Cuenta'}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(''); }}
              className="text-sm text-[var(--violet)] hover:underline"
              data-testid="toggle-auth-mode"
            >
              {mode === 'login' ? 'No tienes cuenta? Registrate' : 'Ya tienes cuenta? Inicia sesion'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
